import { render } from "./TopixTrend.vue?vue&type=template&id=e0b261cc&scoped=true"
import script from "./TopixTrend.vue?vue&type=script&lang=js"
export * from "./TopixTrend.vue?vue&type=script&lang=js"

import "./TopixTrend.vue?vue&type=style&index=0&id=e0b261cc&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b261cc"]])

export default __exports__